/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Parties_1Inputs */

const da_terms_parties_1 = /** @type {(inputs: Terms_Parties_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betingelserne gælder for alle, der bruger AImforA, og for køb af abonnementer og ekstra besvarelser.`)
};

/** @type {(inputs: Terms_Parties_1Inputs) => LocalizedString} */
const en_terms_parties_1 = da_terms_parties_1;

/**

* @param {Terms_Parties_1Inputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const terms_parties_1 = /** @type {((inputs?: Terms_Parties_1Inputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Parties_1Inputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_terms_parties_1(inputs)
	return /** @type {LocalizedString} */ ("Betingelserne gælder for alle, der bruger AImforA, og for køb af abonnementer og ekstra besvarelser.")
});